import useSWRMutation from 'swr/mutation';
import { FetcherArg, fetcherPost } from './httpClient';
import { useAuth } from '../../context/AuthProvider';
import type { EmptyJobRequest } from '../contracts/EmptyJobRequest';

export const useSyncToSupabase = (jobId?: string) => {
  const { session } = useAuth();
  const path = jobId ? `jobs/${jobId}/update-products` : null;
  return useSWRMutation<
    any,
    Error,
    string | null,
    Omit<FetcherArg<EmptyJobRequest>, 'token'>
  >(path, async (url: string, { arg }) =>
    fetcherPost<EmptyJobRequest, any>(url, {
      arg: { ...arg },
      token: session?.access_token ?? '',
    })
  );
};
